<template>
  <div
    class="d-flex align-center text-center justify-center"
    style="height: calc(100vh - 33px)"
  >
    <div>
      <center>
        <v-img
          class="brand"
          src="https://widget.ocularsolution.com/service/ocular/images/logoocular.jpg"
          aspect-ratio="1"
          width="150"
          style="border-radius: 50%"
        ></v-img>
      </center>
      <div class="px-5 py-10">
        <h1>
          {{ $t("basics.enteringYourAttention") }}
        </h1>
        <h4
          style="font-weight: 100"
          class="text--secondary"
        >
          {{ $t("basics.pleaseWait") }}...  🤝
        </h4>
      </div>
      <v-progress-linear
        indeterminate
        color="primary"
        height="5"
      ></v-progress-linear>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  props: {
    sessionLink: {
      type: Object,
      default: null
    }
  }
})
export default class Go extends Vue {
  mounted () {
    this.goToAttention()
  }

  urlSearchParams() {
    const params = new URLSearchParams('')
    params.set('ocularLinkSessionId', this.sessionLink.session.id)
    params.set('ocularOriginalUrl', this.sessionLink.organization.hostName)
    params.set('ocularLinkStatus', this.sessionLink.status)

    if (this.sessionLink.customer) {
      params.set('ocularCustomer', JSON.stringify(this.sessionLink.customer))
    }

    return params.toString()
  }

  goToAttention () {
    setTimeout(() => {
      const href = this.sessionLink.organization.hostName
      location.href = `${href}?${this.urlSearchParams()}`
    }, 3000)
  }
}
</script>
